export type MercadoPagoBasisTheoryRouteMode = 'challenge' | 'reconcile';

/** Untrusted routing input only; the processor must validate the payment GET. */
export function readMercadoPagoBasisTheoryRouteMode(search: string) {
  const values = new URLSearchParams(search).getAll('mp_bt_mode');
  if (values.length !== 1) return undefined;
  const [mode] = values;
  return mode === 'challenge' || mode === 'reconcile' ? mode : undefined;
}

export function mercadoPagoBasisTheoryRoute(
  token: string,
  paymentId: string,
  search: string,
  mode: MercadoPagoBasisTheoryRouteMode,
) {
  const query = new URLSearchParams(search);
  query.set('mp_bt_mode', mode);
  return `/payment/${token}/${paymentId}?${query.toString()}`;
}
